module.exports = __webpack_public_path__ + "static/media/type_user.836d796c.png";